import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const EmpresaPageController = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);

  const Page = pages[empresaState.page];

  return <Page key={empresaState.page} />;
};

export default EmpresaPageController;
